"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Subscriber = void 0;
var Message_1 = require("./Message");
var Subscriber = /** @class */ (function () {
    function Subscriber(client, logger, guard, topics) {
        var _this = this;
        this.client = client;
        this.logger = logger;
        this.guard = guard;
        this.topics = topics;
        this.listeners = [];
        this.subscribePromise = null;
        this.subscribed = false;
        this.onMessage = function (topic, payload) {
            try {
                if (_this.topics.filter(function (t) { return t === topic; }).length === 0) {
                    return;
                }
                var message_1 = JSON.parse("".concat(payload));
                if (!Message_1.Message.guard(message_1)) {
                    throw new Error("Invalid message.");
                }
                var safePayload_1 = message_1.payload;
                if (!_this.guard.guard(safePayload_1)) {
                    throw new Error("Invalid message payload.");
                }
                _this.listeners.forEach(function (listener) {
                    listener(__assign(__assign({}, message_1), { payload: safePayload_1 }), topic);
                });
            }
            catch (e) {
                _this.logger.warn("Error while handling message: ".concat(e instanceof Error ? e.message : "".concat(e), " (").concat(payload, ")"));
                return;
            }
        };
    }
    Subscriber.prototype.subscribe = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                if (this.subscribePromise == null) {
                    this.subscribePromise = (function () { return __awaiter(_this, void 0, void 0, function () {
                        var client;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, this.client.connect()];
                                case 1:
                                    client = _a.sent();
                                    client.on("message", this.onMessage);
                                    return [4 /*yield*/, client.subscribe(this.topics)];
                                case 2:
                                    _a.sent();
                                    this.subscribed = true;
                                    return [2 /*return*/];
                            }
                        });
                    }); })();
                }
                return [2 /*return*/, this.subscribePromise];
            });
        });
    };
    Subscriber.prototype.unsubscribe = function () {
        return __awaiter(this, void 0, void 0, function () {
            var client;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.subscribePromise == null) {
                            return [2 /*return*/];
                        }
                        this.subscribePromise = null;
                        return [4 /*yield*/, this.client.connect()];
                    case 1:
                        client = _a.sent();
                        return [4 /*yield*/, client.unsubscribe(this.topics)];
                    case 2:
                        _a.sent();
                        client.off("message", this.onMessage);
                        this.subscribed = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    Subscriber.prototype.on = function (event, cb) {
        return __awaiter(this, void 0, void 0, function () {
            var client;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.client.connect()];
                    case 1:
                        client = _a.sent();
                        switch (event) {
                            case "message":
                                this.listeners.push(cb);
                                break;
                            default:
                                client.on(event, cb);
                                break;
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    Subscriber.prototype.off = function (event, cb) {
        return __awaiter(this, void 0, void 0, function () {
            var client;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.client.connect()];
                    case 1:
                        client = _a.sent();
                        switch (event) {
                            case "message":
                                this.listeners = this.listeners.filter(function (listener) { return listener !== cb; });
                                break;
                            default:
                                client.off(event, cb);
                                break;
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    return Subscriber;
}());
exports.Subscriber = Subscriber;
//# sourceMappingURL=Subscriber.js.map